<template>
  <d-page>
    <van-image fit="cover" class="bg" :src="require('@/assets/images/VR/bg.png')" />

    <ul class="content">
      <router-link
        tag="li"
        class="content-item"
        :to="{ path: '/vr/detail?id=' + item.id }"
        v-for="item in list"
        :style="{ background: 'url(' + item.image + ') no-repeat center center', 'background-size': '100% 100%' }"
      >
        <p class="content-item-text">{{ item.title }}</p>
      </router-link>
    </ul>
  </d-page>
</template>

<script>
  import { apiConfigVrListVr } from '@/generated_api/resource'

  export default {
    name: 'index',
    data() {
      return {
        list: []
      }
    },
    created() {
      this.getVrList()
    },
    methods: {
      getVrList() {
        apiConfigVrListVr().then(data => {
          this.list = data
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 250px;
  }

  .content {
    width: 375px;
    background: #f5f5f5;
    border-radius: 12px 12px 0px 0px;
    z-index: 1;
    position: absolute;
    top: 215px;
    padding: 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    &-item {
      width: 169px;
      height: 100px;
      position: relative;
      margin-bottom: 12px;
      border-radius: 12px;

      &-text {
        width: fit-content;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: #ffffff;
        line-height: 22px;
        position: absolute;
        bottom: 12px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
</style>
